(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (
        this.contains(document.activeElement) ||
        [...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)
      ) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  if (!customElements.get('tccs-brand-browser')) {
    class TccsBrandBrowser extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.cards = Array.from(this.querySelectorAll('[data-brand-card]'));
        this.searchInput = this.querySelector('[data-brand-search]');
        this.clearButton = this.querySelector('[data-brand-clear]');
        this.letterButtons = Array.from(this.querySelectorAll('[data-brand-letter]'));
        this.resultCount = this.querySelector('[data-brand-count]');
        this.emptyState = this.querySelector('[data-brand-empty]');
        this.activeLetter = '';

        if (!this.searchInput || !this.cards.length) return;

        this.cards.forEach((card) => {
          card.dataset.brandSearchValue = this.normalize(card.dataset.brandName);
          card.dataset.brandInitial = this.getInitial(card.dataset.brandName);
        });

        this.searchInput.addEventListener('input', () => this.applyFilters());
        this.searchInput.addEventListener('search', () => this.applyFilters());
        this.clearButton.addEventListener('click', () => {
          this.searchInput.value = '';
          this.searchInput.focus();
          this.applyFilters();
        });

        this.letterButtons.forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            this.activeLetter = button.dataset.brandLetter || '';
            this.applyFilters();
          });
        });

        this.updateLetterAvailability();
        this.dataset.enhanced = 'true';
        this.applyFilters();
      }

      normalize(value) {
        return String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim()
          .toLowerCase();
      }

      getInitial(value) {
        const firstCharacter = this.normalize(value).charAt(0).toUpperCase();
        return /^[A-Z]$/.test(firstCharacter) ? firstCharacter : '#';
      }

      updateLetterAvailability() {
        const initials = new Set(this.cards.map((card) => card.dataset.brandInitial));

        this.letterButtons.forEach((button) => {
          const letter = button.dataset.brandLetter || '';
          button.disabled = letter !== '' && !initials.has(letter);
        });
      }

      applyFilters() {
        const query = this.normalize(this.searchInput.value);
        let visibleCount = 0;

        this.cards.forEach((card) => {
          const matchesSearch = query === '' || card.dataset.brandSearchValue.includes(query);
          const matchesLetter = this.activeLetter === '' || card.dataset.brandInitial === this.activeLetter;
          const isVisible = matchesSearch && matchesLetter;

          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        this.letterButtons.forEach((button) => {
          const isActive = (button.dataset.brandLetter || '') === this.activeLetter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        this.clearButton.hidden = query === '';
        this.emptyState.hidden = visibleCount !== 0;

        const resultLabel = visibleCount === 1 ? this.dataset.resultSingular : this.dataset.resultPlural;
        this.resultCount.textContent = `${visibleCount} ${resultLabel}`;
      }
    }

    customElements.define('tccs-brand-browser', TccsBrandBrowser);
  }

  } catch(e) { console.error(e); }
})();
})();
